export default {
    'app.welcome.1': 'Welcome to',
    'app.welcome.2': 'BioCertica Practitioners Portal',
    'app.welcome.subheader': 'Empower your patients to lead a healthier lifestyle supported by genetic science. ',
    'common.ok': 'Ok',
    'common.note': 'Note:',
    'common.cancel': 'Cancel',
    'common.save': 'Save',
    'common.acceptToS': 'Accept Terms of Service',
    'common.login': 'Log in with email',
    'common.logout': 'Sign out',
    'common.register': 'Create an Account',
    'common.registerQues': 'New to BioCertica?',
    'common.termsOfService': 'Terms',
    'common.privacyPolicy': 'Privacy and Security',
    'common.contact': 'Get in touch',
    'common.success': 'Success!',
    'common.error': 'Error occured!',
    'common.edit': 'Edit',
    'common.success.upload': 'File uploaded successfully',
    'common.error.upload': 'Error occured while uploading',
    'common.settings': 'Settings',
    'common.goToHomePage': 'Go to home page',

    'my.practice': 'My practice',
    'my.sessions': 'Your sessions',
    'all.sessions': 'View all sessions',
    other: 'Other',

    'v2.contactUs': 'Contact us',
    'v2.privacyPolicy': 'Privacy Policy',
    'v2.termsConditions': 'Terms & Conditions',
    'biocertica.copyright': 'Copyright © 2022 BioCertica',

    'session.accept': 'Accept session',
    'session.results.view': 'View results',
    'session.journal.open': 'Open journal',

    'dashboard.welcome': 'Welcome to the practitioners portal.',
    'sessions.empty':
        'You can now easily schedule a consultation with your patients who have done a genetic test. Once a patient requests a session, you will be able to accept or reject it, and edit its status here. ',
    'sessions.intro': 'See all the sessions that you have going on here',
    'sessions.status.scheduled': 'Session scheduled',
    'sessions.status.accepted': 'Session accepted',
    'sessions.status.declined': 'Session declined',
    'sessions.status.completed': 'Session completed',

    'session.accept.error': 'Error occurred while accepting session',
    'session.decline.error': 'Error occurred while declining session',

    'decline.confirm': 'Confirm',
    'decline.cancel': 'Cancel',
    'decline.confirm.description': 'Session rejected',
    'accept.confirm.description': 'Session accepted',

    'overview.loading': 'Overview loading, please wait.',

    'modal.dismiss': 'Dismiss',
    'modal.dismiss.session': 'You have rejected a pending request for a session.',
    'modal.dismiss.session.description.pt1':
        'You are about to reject pending request for a session. Are you sure you want to proceed?',
    'modal.dismiss.session.description.pt2': 'This action cannot be undone.',
    'modal.confirm.decline': 'Reject request',
    'modal.session.reject': 'Reject session',

    'vitamins.empty': 'User has no packages with Vitamins results purchased.',
    'minerals.empty': 'User has no packages with Minerals results purchased.',

    'modal.accept.session.pt1': 'You have accepted a pending request from',
    'modal.accept.session.pt2': 'for a session',

    'return.sessions': 'Return to Sessions',

    'results.filter': 'Filter',
    'results.products': 'Products',

    'overview.for': 'Overview for',
    'card.number': 'Card number',
    'user.contact': 'Contact',
    'user.report': 'Report generated',
    'session.actions': 'Session actions',
    'button.journal.write': 'Write a journal note',
    'button.data.request': 'Request data',
    'button.data.request.kit': 'Request Data by BioCertica Card',

    'reports.therapy': 'Therapies',
    'reports.title': 'Pharmaco reports',
    'reports.quick': 'Quick view',
    'reports.custom': 'Custom filtering',
    'reports.category.caption':
        'Type of drug from a medical perspective, according to organic systems and conditions they are used to treat.',
    'reports.therapy.caption':
        'Categorization from a pharmacological perspective, mechanism of action and by biological target',
    'reports.tradeName.caption': 'A generic drug name under which the drug is marketed.',
    'reports.genes.caption': 'Gene(s) name(s) that interact with a drug.',
    'reports.metabolizer.caption': 'Classification according to how quickly your body processes the drug.',
    'reports.name.caption': 'Chemical name of active substance',

    'custom.filtering.title': 'Filtering & sorting',
    'custom.filtering.groups.title': 'Filter groups',
    'custom.filtering.groups.desc':
        'Checking a filter will add it to the customisation section. Therefore you will be able to configure the results',
    'custom.filtering.groups.warning': 'At least 3 filters must be configured before Diseases can be generated.',
    'custom.filtering.variables.title': 'Added filter variables',
    'custom.filtering.variables.empty': 'There are no added variables.',
    'custom.filtering.variables.warning': 'At least 2 filters must be configured before results can be generated.',
    'custom.filtering.empty.title': 'Select filter variable to configure',
    'custom.filtering.empty.desc': 'To customise a filter variable, you need to select one from the middle column.',

    'filter.reset': 'Reset all filters',
    'filter.apply': 'Apply filters',

    'session.quick.actions': 'Quick actions',
    'session.highlights': 'Highlights',
    'session.packages': 'Packages',

    'sessions.genotypeData': 'Genotype data',
    'sessions.genotypeData.title': 'Screening & Results',
    'results.open': 'Open results',
    'result.score.overall': 'Overall score',

    'session.notes': 'Notes',
    'session.notes.title': 'Write a journal note',
    'session.notes.write': 'Write a note',
    'session.notes.empty': 'No notes yet',
    'session.notes.existing': 'Notes ready',

    'session.supplements.nutrition': 'NUTRITION',
    'session.supplements.customSupplements': 'Custom Supplements',
    'session.supplements.createCustomBlend': 'Create a custom blend for your patient.',
    'session.supplements.learnMore': 'Learn more',
    'session.supplements.getStarted': 'Get started',

    'session.summary.dateLabel': 'REPORT DATE:',
    'session.summary.reportSummaryTitle': 'Report Summary',
    'session.summary.geneticRiskTitle': 'Genetic Risk Areas',
    'session.summary.geneticHighlightsTitle': 'Genetic Highlights',
    'session.summary.generateButton': 'Generate summary',
    'session.summary.generatingDescription':
        'Generating summary. This can take up to 15 seconds. Feel free to view the rest of your report while waiting.',
    'session.summary.packageLabel': 'Package reports',

    'table.header.name': 'Name',
    'table.header.email': 'Email',
    'table.header.phone': 'Phone',
    'table.header.status': 'Status',

    'button.session.journal': 'Write in Journal',

    'journal.button.submit': 'Create medical journal entry',
    'journal.button.save': 'Save and edit later',
    'journal.status.saved': 'Saved',
    'journal.status.submitted': 'Submitted',
    'journals.empty': 'After a session with a patient, you will be able to enter your notes in their Journal here.',

    'header.data': 'Data',
    'header.shared': 'Shared',
    'header.status': 'Status',

    'table.empty': 'No data to show',
    'table.quickView.empty': 'Please select at least one filter to show the results.',
    'genotypes.header.effects': 'Effects & Alleles',
    'genotypes.header.genotype': 'Genotype',
    'genotypes.header.allele': 'Effect Allele',
    'genotypes.header.effectWeight': 'Effect Weight',

    'settings.practice.title': 'Practice info',

    'settings.warehouse.title': 'Warehouse info',

    'settings.payment.title': 'Payment info',

    'settings.description': 'Short description about yourself',
    'settings.practitioner.type': 'Type of practitioner',
    'settings.HPCSA': 'HPCSA',
    'settings.practice.number': 'Practice Number',
    'settings.profile.picture': 'Profile Picture',

    'practitioner.type.resourcing': 'Resourcing Practitioner',
    'practitioner.type.general': 'General Practitioner',
    'practitioner.type.nutricionist': 'Nutricionist',

    'session.status.pending': 'Pending sessions',
    'session.status.inprogress': 'Accepted sessions',
    'session.status.completed': 'Completed sessions',

    'notFoundPage.title': 'This page is unknown or does not exist',
    'notFoundPage.text':
        'The link you followed is either outdated or inaccurate, please click on the button below to return to login.',
    'notFoundPage.button.text': 'Go to home',

    'result.genes': 'Genes: ',
    'result.title.symptopms': 'Symptoms',
    'result.title.recommendation': 'Recommendation',
    'result.title.effects': 'Effects & Alleles',
    'result.title.genes': 'Genes',
    'results.back': 'Back to products',
    notes: 'Notes',

    'journal.edit': 'Continue Editing',
    'journal.submit.confirm': 'Yes, Submit Journal',

    'journal.submit.modal.title': 'Submit journal notes?',
    'journal.modal.pt1': 'You are about to submit journal notes to the patient?',
    'journal.modal.pt2': `After you submit journal notes, the session will be complete and you will not be able to see patient's data.`,
    'journal.save.changes': 'Save Changes',
    'journal.submit': 'Submit Journal',
    'journal.instructions': 'Instructions',
    'journal.instructions.description':
        'Give lifestyle recommendations to your user based on your expertise and interpretation of their PRS results. Give recommendation of other BioCertica tests they might need to take.',

    'journal.instructions.step1': '1. Try to write clear sentences',
    'journal.instructions.step2': '2. Do not use technical words too much',
    'journal.instructions.step3': '3. Be specific',

    'journal.requestdata': 'Request data',
    'journal.requestdata.description':
        'You can request data from BioCertica for this user in order to gain quicker access to users data and avoid having user going through purchase flow.',

    'journal.requestdata.modal.title': 'You are about to request data for this patient!',
    'journal.requestdata.modal.content1':
        'The patient will receive a request on their BioCertica mobile app, and confirm or decline data sharing. If accepted, you can proceed with the session.',
    'journal.requestdata.modal.content2':
        'You will need to pay the agreed fee with BioCertica within 14 days from this day',

    'questionnaires.empty': 'No questionnaire data available.',

    'warehouse.new.title': 'Create a new warehouse',
    'warehouse.create': 'Create',
    'warehouse.empty': 'Practitioner needs to be accepted in order to access this section.',
    'warehouse.contactNumber': 'Contact number:',
    'warehouse.contactPerson': 'Contact person:',
    'warehouse.countryCode': 'Country code:',
    'warehouse.name': 'Warehouse name:',
    'warehouse.postalCode': 'Postal code:',
    'warehouse.state': 'State:',
    'warehouse.streetAddress': 'Street address:',
    'warehouse.suburb': 'Suburb:',
    'warehouse.update': 'Update warehouse',

    'discount.empty': 'You don’t have any coupons yet.',
    'discount.create': 'Create discount code',
    'discount.rule': 'Discount rule',
    'discount.set': 'Discount code',
    'discount.set.random': 'Generate random code',
    'discount.set.upsell': 'Upsell',
    'discount.options': 'Options',
    'discount.shipping': 'Shipping',
    'discount.shipping.desc': 'Item requires shipping',
    'discount.add-new-kit': `I want to add a new kit`,

    'summary.subtitle': 'Everything about your practice in one place',
    'summary.latest.transactions': 'Latest transactions',
    'summary.back': 'Back to Summary',

    'course.subtitle': 'Watch a webinar and complete the course test',
    'course.test': 'Take the course and the practitioners test',

    'course.test.description':
        'In order to give consultations to patients, you need to take the BioCertica practitioners course. After you successfully complete all course materials, you will be able to take the practitioners test. This is required in order for your practice to become available in the BioCertica app. The course is designed to facilitate your onboarding to BioCertica and support your knowledge about genomics.',

    'course.test.descriptionpt1':
        'You are obligated to take and fulfill the minimum requirements and watch the Webinar and take Thinkific course.',
    'course.test.descriptionpt2':
        'After you successfully complete all course materials, you will be able to take the practitioners test. This is required in order for your practice to become available in the BioCertica app.',

    'warehouse.create.description': 'Taking kits into consignment? Fill out this form.',
    'warehouse.update.description': 'Update your warehouse data:',
    'warehousing.subtitle': 'Manage your warehouse',
    'warehousing.emptyStateTitle': 'Register your Warehouse',
    'warehousing.emptyStateSubtitle': 'You currently don’t have a Warehouse registered to your practice.',
    'warehousing.emptyStateContent':
        'Taking kits into consignment will require to fill the Warehouse details. After necessary information are filled up, BioCertica will assign you a specific number of kits.',
    'warehousing.emptyState.button': 'Register warehouse',

    'kits.available': 'Available items in stock',
    'kits.sold': 'Sold kits',

    'payment.details.empty': 'Practitioner needs to be accepted in order to access this section.',
    'payment.details.new': 'Payment details',
    'my.payment.list': 'My payment methods',
    'payment.details.edit': 'Save method',
    'payment.details.close': 'Cancel',

    'payment.currency': 'Currency for profit payment to the practitioner:',
    'payment.type': 'Type of payment:',
    'payment.identifier': 'Payment identifier:',
    'payment.details.create': 'Add New Payment Method',

    'card.identifier.placeholder': 'Bank account number',
    'paypal.identifier.placeholder': 'PayPal account mail or phone number',
    'default.identifier.placeholder': 'Please select type of payment first.',

    'payment.new.success': 'New payment details added successfully.',
    'payment.new.error': 'Error occurred while adding new payment details.',
    'payment.edit.success': 'Payment details updated successfully.',
    'payment.edit.error': 'Error occurred while updating payment details.',

    'payment.table.header.id': 'ID',
    'payment.table.header.createdAt': 'Created at',
    'payment.table.header.identifier': 'Identifier',
    'payment.table.header.type': 'Payment type',
    'payment.table.header.updatedAt': 'Updated at',
    'payment.table.header.currency': 'Currency',

    'questionnaire.choice.empty': 'No choices have been provided for this question.',

    'kit.ancestry': 'Ancestry',

    'kits.description': 'See the kits assigned to your stock.',
    'kits.empty': 'No kits have been assigned to your stock.',
    'table.kit.id': 'ID',
    'table.kit.collections': 'Collections',
    'table.kit.sample': 'Sample Label',
    'currency.select': 'Select currency',

    'options.none': 'No options have been provided.',

    'view.all.transactions': 'View all transactions',

    'practice.confirmation.pt1':
        'You have successfully registered Nutrition Coach as your practice on BioCertica. Our team will review your practice and information your have provided and you will receive an email with confirmation.',
    'practice.confirmation.pt2': 'This may take a few hours.',
    'practice.confirmation.pt3': 'While you wait for approval, you may take a Demo tour of our Portal.',

    'copyright.biocertica': 'Copyright © 2022 BioCertica',
    'footer.description':
        'By signing in and/or creating new account, you agree to BioCertica’s Privacy Policy and Terms & Conditions',

    'errors.MIN_NOT_REACHED': 'Minimum chars not reached',
    'errors.MAX_EXCEEDED': 'Maximum chars exceeded',
    'errors.INVALID_EMAIL': 'Email is not valid',
    'errors.INVALID_NUMBER': 'Value is not valid.',
    'errors.NO_LOWERCASE': 'At least one lowercase letter is required',
    'errors.NO_UPPERCASE': 'At least one uppercase letter is required',
    'errors.NO_MATCH': 'Has to be same',
    'errors.NO_NUMBER': 'At least one number is required',
    'errors.REQUIRED': 'This field is required',
    'errors.GENERAL_ERROR_TITLE': 'Something went wrong',
    'errors.0': 'Unexpected error occured',
    'errors.400400': 'Bad request',
    'errors.400401': 'Unexpected error occured',
    'errors.400403': 'Not authorized to access this resource',
    'errors.400409': 'User deactivated',
    'errors.400414': 'User needs to progress properly through statuses',
    'errors.400415': 'Min date is 1 day from now, max date is 7 days from now',
    'errors.400416': 'You are trying to assign an already taken kit',
    'errors.409000': 'Email already taken',
    'errors.500419': 'Internal issue while communicating to downstream service',
    'errors.500500': 'Internal issue while generating jwt',
    'errors.500505': 'Internal issue while fetching resource',
    'errors.500506': 'Internal issue while inserting resource',
    'errors.500507': 'Internal issue while updating resource',
    'errors.500508': 'Internal issue while deleting resource',
    'errors.logoutFailureFallbackError': 'Error occured while logging out',
    'errors.SESSION.050': 'You have already requested data for this user.',

    // ASK AI
    'ai.askAi': 'Ask AI',
    'ai.getRecommendation': 'Want to get an AI recommendation based on this profile?',
    'ai.generateRecommendation': 'Generate AI Recommendation',
    'ai.askRecommendation': 'Ask AI for Recommendation',
    'ai.getSummary': 'Get a summary generated by AI based on this patients data and kit.',
    'ai.disclaimerTitle': 'Important Disclaimer on AI-Generated Medical Information',
    'ai.disclaimerBody':
        'The information provided by this AI is for general informational purposes only and does not constitute medical advice, diagnosis, or treatment. While AI can help explain medical concepts and guide research, it is not a substitute for professional judgment.',

    // TailorBlend

    'tailorblend.supplierBlock': 'View',
    'tailorblend.suppliers': 'Suppliers',
    'tailorblend.supplementDetails.customSupplements': 'Custom Supplements',
    'tailorblend.supplementDetails.pendingPermission': 'Permission request pending',
    'tailorblend.supplementDetails.sharePatientPermissionData':
        'Patient has granted permission to share their data to create a custom supplement.',
    'tailorblend.supplementDetails.createBlend': 'Create blend',
    'tailorblend.supplementDetails.customSupplement': 'Custom Supplements',
    'tailorblend.supplementDetails.about': 'About',
    'tailorblend.supplementDetails.howItWorks': 'How it works',
    'tailorblend.supplementDetails.whyProvider': 'Why {ProviderName}?',
    'tailorblend.supplementDetails.permissionToShareThisPatient': 'Request permission to share this patient',
    'tailorblend.supplementDetails.DNAResultsToCreateTheirPersonalisedBlend':
        's DNA results to create their personalised blend. Once approved, you will be notified to proceed.',

    'tailorblend.supplementDetails.requestPermission': 'Request permission',

    'tailorblend.permissionRequestModal.requestPermission': 'Request permission',
    'tailorblend.permissionRequestModal.youNeedPermissionFromPatient':
        'You need permission from your patient before you can share their DNA results with',
    'tailorblend.permissionRequestModal.sendPermissionRequest':
        'Send a permission request and you will be notified when your patient grants permission.',
    'tailorblend.permissionRequestModal.cancel': 'Cancel',
    'tailorblend.permissionRequestModal.sendRequestPermission': 'Send permission request',
};
